import { cx } from "@emotion/css";
import { ReactNode, useEffect, useRef, useState } from "react";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";

interface LongTextProps {
	children: ReactNode;
	className?: string;
}

export const LongText = ({ children, className }: LongTextProps) => {
	const textRef = useRef<HTMLSpanElement>(null);
	const [isTruncated, setIsTruncated] = useState(false);

	useEffect(() => {
		const element = textRef.current;
		if (element) {
			if (element.scrollHeight > element.clientHeight) {
				setIsTruncated(true);
			} else {
				setIsTruncated(false);
			}
		}
	}, []);

	return (
		<Tooltip
			title={children}
			disabled={!isTruncated}
			wrapperClassName="first-letter-upper"
		>
			<span ref={textRef} className={cx(className, "text-ellipsis-1")}>
				{children}
			</span>
		</Tooltip>
	);
};
